import { URL_PREFIX } from "../constants/stores";


export const getAllocationList = async ( token: string,poId: number) => {

    try {
        const response = await fetch(`${URL_PREFIX}/allocation/getPoNo/${poId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            // body: JSON.stringify({ poId}),
        });
        if (response.status === 204) {
            return null;
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.log('Error fetching PONO:', error);
    }
}

export const getStyleList = async ( token: string,poId: number) => {

    try {
        const response = await fetch(`${URL_PREFIX}/allocation/getStyles`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({ poId}),
        });
        if (response.status === 204) {
            return null;
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.log('Error fetching PONO:', error);
    }
}